export const TEMPORARY_ID_PREFIX = 'temp:';

export const generateTemporaryId = (): string => {
  return TEMPORARY_ID_PREFIX + window.crypto.randomUUID();
};

export const isTemporaryId = (id: string): boolean => {
  return id.startsWith(TEMPORARY_ID_PREFIX);
};

export const clearTemporaryId = (id: string): string | null => {
  return id.startsWith(TEMPORARY_ID_PREFIX) ? null : id;
};

export const clearTemporaryIdPrefix = (id: string): string | null => {
  // Empty means "no refKey": the API binds these to Guid?, and "" fails to deserialize, which
  // rejects the whole request body with 400 "The model field is required." (EWM-790 e2e).
  if (!id) return null;
  return id.startsWith(TEMPORARY_ID_PREFIX) ? id.slice(TEMPORARY_ID_PREFIX.length) : id;
};

export const transformToTemporaryId = (id: string): string => {
  return isTemporaryId(id) ? id : TEMPORARY_ID_PREFIX + id;
};
